import type { UserNotificationType } from "@shared/graphql.types";
import { ExperimentFlags } from "@shared/utils.experimentation";
import { setNotifications } from "lib/notifications";

/* @todo (mattd) rename or refactor out */
export function updateUserNotificationsInCache(
  notifications: UserNotificationType[] | Error
): void {
  if (notifications instanceof Error) {
    setNotifications([notifications]);
  } else {
    setNotifications(notifications);
  }
}

export function shouldUseNewPromotionalBanner(
  experimentFlags: Record<string, string | number | boolean> | undefined = {},
  layout?: string | null | undefined
): boolean {
  return (
    (!layout || layout === "DefaultLayout" || layout === "QuizLayout") &&
    +experimentFlags?.[ExperimentFlags.PAGE_EXPERIMENT_PROMOTIONAL_BANNER] === 1
  );
}
